import Vue from 'vue'

export default Vue.extend({
  computed: {
    versions (): String[] {
      const release = this.$store.direct.state.admin.release
      if (release === null) return []
      else return Object.keys(release.versions)
    },
    defaultVersion (): String {
      const release = this.$store.direct.state.admin.release
      if (release === null) return '3.6.3'
      else return release.default
    }
  },
  mounted () {
    this.$store.direct.dispatch.admin.subscribeRelease()
  },
  beforeDestroy () {
    this.$store.direct.dispatch.admin.unsubscribeRelease()
  }
})
